import { FEATURES } from "../constants";

export type Feature = (typeof FEATURES)[number];

export function isFeature(feature: string): feature is Feature {
  return FEATURES.includes(feature as Feature);
}
